import * as React from "react";
import { useEffect } from "react";
import { MetricsActions, MetricsStore } from "stores/metrics/MetricsStore";
import { useStore } from "stores/connect";
const MetricsMapper = ({ map, computeValue }) => {
  const { metrics } = useStore(MetricsStore);
  useEffect(() => {
    Object.keys(map).forEach((name) => MetricsActions.addGlobal(map[name]));
    return () => {
      Object.keys(map).forEach((name) => MetricsActions.removeGlobal(map[name]));
    };
  });
  if (!metrics) {
    return null;
  }
  const metricsMap = {};
  Object.keys(metrics).forEach((nodeId) => {
    Object.keys(map).forEach((key) => {
      const metricName = map[key];
      if (metrics[nodeId][metricName]) {
        if (!metricsMap[nodeId]) {
          metricsMap[nodeId] = {};
        }
        metricsMap[nodeId][key] = metrics[nodeId][metricName];
      }
    });
  });
  const value = computeValue(metricsMap);
  return /* @__PURE__ */ React.createElement("span", null, value);
};
export default MetricsMapper;
